<template>
    <b-alert class="mt-3 mb-3 w-100" variant="light" show>
        <div class="text-center">
            <fa-icon icon="circle-notch" size="4x" spin></fa-icon>
        </div>
    </b-alert>
</template>

<script>
export default {

}
</script>